import React, { useContext, useEffect } from 'react';
import BranchTable from './ChannelTable';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { CardHeader } from '@mui/material';
import FilterBar from './FilterBar';
import Button from '@mui/material/Button';
import { ChannelContext, CommonContext } from '../../context';
import AddChannel from './AddChannel';
import Loader from '../common/Loader';
import AlertMessage from '../common/AlertMessage';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const ChannelScreenView = () => {
  const { handleAddModal, isLoading, onLoadApi } = useContext(ChannelContext);
  const { openAlert, user } = useContext(CommonContext);
  const navigate = useNavigate();
  const location = useLocation();
  const merchantData = location.state;

  useEffect(() => {
    onLoadApi(merchantData?.id);
  }, []);

  return (
    <div className='main-screen'>
      {openAlert && <AlertMessage />}
      {isLoading && <Loader />}
      <AddChannel />

      {(user?.user_type !== 'Merchant' && merchantData) && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }}>
          <Button
            variant="outlined"
            className="action-btn"
            onClick={() => navigate('/merchants/registered')}
            startIcon={<ArrowBack />}
            sx={{ mt: 2 }}
          >
            Back to Merchants
          </Button>
        </Box>
      )}

      <Box className="component-header">
        <CardHeader
          title={
            <span>
              Channel {merchantData && <span style={{ fontSize: '18px', color: '#333', fontWeight: 600 }}>- {merchantData.company_name}</span>}
            </span>
          }
        />
        <Box className="action-btns-group">
          <Button variant="outlined" className="action-btn" onClick={handleAddModal}>
            Add Channel
          </Button>
        </Box>
      </Box>
      <Paper sx={{ boxShadow: 'none' }}>
        <FilterBar />
        <BranchTable />
      </Paper>
    </div>
  );
}

export default ChannelScreenView;